import { render } from "./ClientPlanTab.vue?vue&type=template&id=749a4a4d"
import script from "./ClientPlanTab.vue?vue&type=script&lang=js"
export * from "./ClientPlanTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__